/**
 * Returns a varied, time- and day-aware greeting string.
 * Uses the day-of-month as a stable daily seed so it doesn't flicker on re-renders.
 */

const MORNING = [
  "Good morning",
  "Rise and shine",
  "Great morning to you",
  "Start your day right",
  "Morning check-in",
];

const AFTERNOON = [
  "Good afternoon",
  "Hope your day is going well",
  "Great to see you",
  "Afternoon check-in",
  "Welcome back",
];

const EVENING = [
  "Good evening",
  "Evening check-in",
  "Good to see you",
  "Hope you had a great day",
  "Welcome back",
];

const WEEKEND = [
  "Happy weekend",
  "Good to see you",
  "Welcome back",
  "Weekend banking, sorted",
  "Great to have you here",
];

const MONDAY = [
  "New week, fresh start",
  "Happy Monday",
  "Let's make this week count",
];

const FRIDAY_EVENING = [
  "Happy Friday!",
  "Almost the weekend!",
  "TGIF — you've earned it",
];

/**
 * @returns {string} A greeting phrase (English). Wrap with t() at the call site.
 */
export const getGreeting = () => {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay();   // 0 = Sun, 6 = Sat
  const seed = now.getDate(); // 1–31, changes daily for variety

  // Weekend
  if (day === 0 || day === 6) return WEEKEND[seed % WEEKEND.length];

  // Monday morning
  if (day === 1 && hour < 12) return MONDAY[seed % MONDAY.length];

  // Friday afternoon / evening
  if (day === 5 && hour >= 14) return FRIDAY_EVENING[seed % FRIDAY_EVENING.length];

  // Time-of-day
  if (hour < 12) return MORNING[seed % MORNING.length];
  if (hour < 18) return AFTERNOON[seed % AFTERNOON.length];
  return EVENING[seed % EVENING.length];
};
